import { FC } from "react";

/** 与 33.AI转录.html 内嵌脚本的 icons 路径完全一致，勿改成 lucide。 */
export const TRANSCRIPTION_ICON_PATHS: Record<string, string> = {
  upload:
    '<path d="M12 16V3m-5 5 5-5 5 5M4 15v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5"/>',
  video:
    '<rect x="3" y="4" width="18" height="16" rx="3"/><path d="m10 8 6 4-6 4z"/>',
  headphones:
    '<path d="M3 14v-3a9 9 0 0 1 18 0v3M3 13h4v8H5a2 2 0 0 1-2-2zm18 0h-4v8h2a2 2 0 0 0 2-2z"/>',
  file: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h6"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  arrow: '<path d="M4 12h16m-6-6 6 6-6 6"/>',
  chevron: '<path d="m9 5 7 7-7 7"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/>',
  sparkles:
    '<path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5zM20 2v4m-2-2h4"/>',
  shield:
    '<path d="m12 2 8 4v6c0 5-8 10-8 10S4 17 4 12V6zM8 12l3 3 5-6"/>',
  coins:
    '<circle cx="12" cy="12" r="9"/><path d="M15 8h-4a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4H9m3-10v12"/>',
  book: '<path d="M12 5v16M12 5C9 2 3 3 2 4v15c3-1 7-1 10 2 3-3 7-3 10-2V4c-3-1-7-2-10 1"/>',
  menu: '<path d="M4 6h16M4 12h16M4 18h16"/>',
  sliders:
    '<path d="M4 7h5m4 0h7M4 17h9m4 0h3"/><circle cx="11" cy="7" r="2"/><circle cx="15" cy="17" r="2"/>',
  x: '<path d="M6 6l12 12M6 18 18 6"/>',
  copy: '<rect x="8" y="8" width="12" height="13" rx="2"/><path d="M16 8V3H3v13h5"/>',
  refresh: '<path d="M20 8a8 8 0 1 0 1 7M20 3v5h-5"/>',
  image:
    '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8" cy="8" r="2"/><path d="m3 17 6-6 4 4 3-3 5 5"/>',
  user: '<circle cx="12" cy="7" r="4"/><path d="M4 22v-3a8 8 0 0 1 16 0v3"/>',
  radio:
    '<circle cx="12" cy="12" r="2"/><path d="M8 6a8 8 0 0 0 0 12m8-12a8 8 0 0 1 0 12M5 3a12 12 0 0 0 0 18M19 3a12 12 0 0 1 0 18"/>',
  zap: '<path d="m13 2-9 12h7l-1 8 10-13h-7z"/>',
  type: '<path d="M3 7V3h18v4M12 3v18M8 21h8"/>',
  mic: '<rect x="8" y="2" width="8" height="13" rx="4"/><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8"/>',
  folder: '<path d="M3 7V4h6l3 3h9v14H3z"/>',
  list: '<path d="M8 6h12M8 12h12M8 18h12M3 6h.01M3 12h.01M3 18h.01"/>',
  layers:
    '<path d="m12 3 10 5-10 5L2 8zm-10 9 10 5 10-5M2 16l10 5 10-5"/>',
  edit: '<path d="m15 3 6 6M4 15 16 3a2 2 0 0 1 5 5L9 20l-6 1z"/>',
  check: '<path d="m5 12 4 4L20 5"/>',
  download: '<path d="M12 3v12m-4-4 4 4 4-4M4 16v5h16v-5"/>',
  more: '<circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/>',
  trash:
    '<path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/>',
  cloudUpload:
    '<path d="M7 17a5 5 0 0 1-1-9.9A6 6 0 0 1 17.6 6a4.5 4.5 0 0 1 1.4 8.8M12 21V11m-4 4 4-4 4 4"/>',
};

interface TranscriptionIconProps {
  name: string;
  className?: string;
}

export const TranscriptionIcon: FC<TranscriptionIconProps> = ({
  name,
  className,
}) => {
  const html = TRANSCRIPTION_ICON_PATHS[name] || TRANSCRIPTION_ICON_PATHS.file;
  return (
    <svg
      className={className ? `icon ${className}` : "icon"}
      viewBox="0 0 24 24"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export const DataIcon: FC<{ name: string; className?: string }> = ({
  name,
  className,
}) => (
  <span className={className} data-icon={name}>
    <TranscriptionIcon name={name} />
  </span>
);
